module.exports = __webpack_public_path__ + "static/media/crash_4.e596e5cb.mp3";